export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["FACULTY"] = "FACULTY";
    UserRole["STUDENT"] = "STUDENT";
    UserRole["OPS_MANAGER"] = "OPS_MANAGER";
    UserRole["TEAM_LEADER"] = "TEAM_LEADER";
    UserRole["COORDINATOR"] = "COORDINATOR";
    UserRole["CONSULTANT"] = "CONSULTANT";
    UserRole["H_MANAGER"] = "H_MANAGER";
    UserRole["LEAD"] = "LEAD";
    UserRole["REPORT_VIEWER"] = "REPORT_VIEWER";
})(UserRole || (UserRole = {}));
